import webhooks_gen_2 from '@devices/settings/device_settings/webhooks_gen_2.js';
import scripts_gen_2 from '@devices/settings/device_settings/scripts_gen_2.js';
import virtual_components from '@devices/settings/device_settings/virtual_components.js';
import networks_gen_2_plus from '@devices/settings/device_settings/networks_gen_2_plus.js';
import share from '@devices/settings/device_settings/share.js';
import emeter_63_settings_monophase_gen_3 from '@devices/settings/common_settings/emeter_63_settings_monophase_gen_3.js';
import bluetooth_gen_2 from '@devices/settings/device_settings/bluetooth_gen_2.js';

export default [
	webhooks_gen_2,
	scripts_gen_2,
	virtual_components,
	networks_gen_2_plus,
	bluetooth_gen_2,
	{
		title: 'application_settings',
		components: [
			{ title: 'ai_model', component: 'ai_model' },
			{
				title: 'device_card_customization',
				component: 'customize_device_content',
			},
			{ title: 'appliance_type', component: 'appliance_type' },
			{
				title: 'consumption_calculation',
				component: 'consumption_calculation',
			},
			{
				title: 'consumption_hierarchy',
				component: 'consumption_hierarchy',
				test_user: true,
			},
			{
				title: 'exclude_forgotten_lights',
				component: 'exclude_forgotten_lights',
				premium: true,
			},
		],
	},
	share,
	emeter_63_settings_monophase_gen_3,
];
